import { toDecimalString } from "../../../../../shared/utils/numbers";

const formaterNumberCell = (value,precision) => value < 0 ? `(${toDecimalString(value*-1,precision)})` : (value>0 ? toDecimalString(value,precision) : '-');
const mayorCien = (value) => value > 0 ? '>100' : '(>100)';

export const subTitlesTableObjReal = (año) => [
    {label:`REAL ${año-1}-12`, colIni:0, colFin:7},
    {label:'', colIni:8, colFin:10},
    {label:`OBJETIVOS ${año} (Δ s/REAL  ${año-1}-12)`, colIni:11, colFin:31}
]

export const columnsTableObjReal = (año) => [
    {
        field: 'conT_REAL',
        name: 'CONT',
        sortable: false,
        'data-test-subj': 'firstNameCell',
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.conT_REAL,0)}</span>),
        width:'110px'
    },
    {
        field: 'facT_REAL',
        name: 'FACT',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.facT_REAL,0)}</span>),
        width:'110px'
    },
    {
        field: 'proD_REAL',
        name: 'PROD',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.proD_REAL,0)}</span>),
        width:'110px'
    },
    {
        field: 'apoR_REAL',
        name: 'APOR',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.apoR_REAL,0)}</span>),
        width:'110px'
    },
    {
        field: 'margen_REAL',
        name: '%MARGEN',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{Math.abs(data.margen_REAL)>100 ? mayorCien(data.margen_REAL) : formaterNumberCell(data.margen_REAL,1)}</span>),
        width:'100px'
    },
    {
        field: 'bdI_REAL',
        name: 'BDI',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.bdI_REAL,0)}</span>),
        width:'110px'
    },
    {
        name: 'S',
        'data-test-subj': 'spaceCell',
        render: () => null,
        width:'5px'
    },
    {
        field: 'carttotaL_REAL',
        name: 'CART TOTAL',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.carttotaL_REAL,0)}</span>),
        width:'110px'
    },
    {
        name: 'S',
        'data-test-subj': 'spaceCell',
        render: () => null,
        width:'10px'
    },
    {
        name: 'Centro',
        'data-test-subj': 'centro',
        sortable: true,
        render: (data) =>(
            <span>{ ((data.idPais!=='@@' && data.idPais!=='A@') ? (data.idPais==='00' ? `NACIONAL` : `INTERNACIONAL`) : `${data.idCentro} - ${data.centro}`)}</span>
        ),
        width:'400px'
    },
    {
        name: 'S',
        'data-test-subj': 'spaceCell',
        render: () => null,
        width:'10px'
    },
    {
        field: 'cont',
        name: 'CONT',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.cont,0)}</span>),
        width:'110px'
    },
    {
        field: 'conT_OBJ_REAL',
        name: `Δ s/${año-1} CONT (%)`,
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{Math.abs(data.conT_OBJ_REAL)>100 ? mayorCien(data.conT_OBJ_REAL) : formaterNumberCell(data.conT_OBJ_REAL,1)}</span>),
        width:'100px'
    },
    {
        name: 'S',
        'data-test-subj': 'spaceCell',
        render: () => null,
        width:'5px'
    },
    {
        field: 'fact',
        name: 'FACT',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.fact,0)}</span>),
        width:'110px'
    },
    {
        field: 'facT_OBJ_REAL',
        name: `Δ s/${año-1} FACT (%)`,
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{Math.abs(data.facT_OBJ_REAL)>100 ? mayorCien(data.facT_OBJ_REAL) : formaterNumberCell(data.facT_OBJ_REAL,1)}</span>),
        width:'100px'
    },
    {
        name: 'S',
        'data-test-subj': 'spaceCell',
        render: () => null,
        width:'5px'
    },
    {
        field: 'prod',
        name: 'PROD',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.prod,0)}</span>),
        width:'110px'
    },
    {
        field: 'proD_OBJ_REAL',
        name: `Δ s/${año-1} PROD (%)`,
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{Math.abs(data.proD_OBJ_REAL)>100 ? mayorCien(data.proD_OBJ_REAL) : formaterNumberCell(data.proD_OBJ_REAL,1)}</span>),
        width:'100px'
    },
    {
        name: 'S',
        'data-test-subj': 'spaceCell',
        render: () => null,
        width:'5px'
    },
    {
        field: 'apor',
        name: 'APOR',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.apor,0)}</span>),
        width:'110px'
    },
    {
        field: 'apoR_OBJ_REAL',
        name: `Δ s/${año-1} APOR (%)`,
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{Math.abs(data.apoR_OBJ_REAL)>100 ? mayorCien(data.apoR_OBJ_REAL) : formaterNumberCell(data.apoR_OBJ_REAL,1)}</span>),
        width:'100px'
    },
    {
        name: 'S',
        'data-test-subj': 'spaceCell',
        render: () => null,
        width:'5px'
    },
    {
        field: 'margen',
        name: '%MARGEN',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.margen,1)}</span>),
        width:'100px'
    },
    // {
    //     field: 'margen_DIF',
    //     name: `Δ s/${año-1} %MARGEN (DIF.)`,
    //     sortable: false,
    //     dataType: 'number',
    //     render: (data) => (<span>{Math.abs(data.margen_DIF)>100 ? '>100' : formaterNumberCell(data.margen_DIF,1)}</span>),
    //     width:'100px'
    // },
    {
        name: 'S',
        'data-test-subj': 'spaceCell',
        render: () => null,
        width:'5px'
    },
    {
        field: 'bdi',
        name: 'BDI',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.bdi,0)}</span>),
        width:'110px'
    },
    {
        field: 'bdI_OBJ_REAL',
        name: `Δ s/${año-1} BDI (%)`,
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{Math.abs(data.bdI_OBJ_REAL)>100 ? mayorCien(data.bdI_OBJ_REAL) : formaterNumberCell(data.bdI_OBJ_REAL,1)}</span>),
        width:'100px'
    },
    {
        field: 'tipO_MED_IMP',
        name: 'Tipo Medio Impositivo',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{Math.abs(data.tipO_MED_IMP)>100 ? mayorCien(data.tipO_MED_IMP) : formaterNumberCell(data.tipO_MED_IMP,1)}</span>),
        width:'100px'
    },
    {
        name: 'S',
        'data-test-subj': 'spaceCell',
        render: () => null,
        width:'5px'
    },

    {
        field: 'carttotal',
        name: 'CART TOTAL',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.carttotal,0)}</span>),
        width:'110px'
    },
    {
        field: 'ccaja',
        name: `CAJA OBJ`,
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.caja,0)}</span>),
        width:'100px'
    }
  ];